import React from 'react';
import { Collapse, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import ProductDetailAttribute from './ProductDetailAttribute';

const { Panel } = Collapse;

// 商品非关键属性 渲染代码
const ProductAttributeWrapper = (props: {
  mmuAttributeList: Array<any>;
  onMmuChange: () => void;
}) => {
  const { mmuAttributeList, onMmuChange } = props;

  const handleChangeMmu = () => {
    onMmuChange();
  };

  return (
    <>
      {mmuAttributeList.map((mmuAttribute) => {
        return (
          <div className="product-filter-type" key={mmuAttribute.attributeSysNo}>
            <div className="product-filter-title" title={mmuAttribute.attributeName}>
              {mmuAttribute.attributeName}
            </div>
            <div className="product-filter-item-wrap">
              <ProductDetailAttribute
                attributeData={mmuAttribute}
                isMmu={true}
                handleChangeMmu={handleChangeMmu}
              />
              {mmuAttribute.attributeName === '区域属性' && (
                <Tooltip
                  overlayInnerStyle={{ width: '400px' }}
                  title={
                    <div>
                      <div>泵类的标号仅供深圳、南京等区域项目选择，其他区域勿选；</div>
                      <div>选择区域属性后，系统将自动拼接强度等级与区域属性推送至云砼；</div>
                      <div>例：强度等级选择【C30】，区域属性选择【泵】，推送时为【C30泵】</div>
                    </div>
                  }
                >
                  <span className="question-icon">
                    <QuestionCircleOutlined />
                  </span>
                </Tooltip>
              )}
            </div>
          </div>
        );
      })}
      <style jsx>{`
        .product-filter {
            margin-top: 20px;
        }
        .product-filter-type {
            display: flex;
        }
        .product-filter-type .product-filter-title {
            padding: 6px 10px 0 20px;
            color: #999;
            max-width: 110px;
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: normal;
            white-space: nowrap;
        }
        .product-filter-title-tag {
          padding: 6px 10px 10px 20px;
          // color: #999;
        }
        .product-filter .product-filter-type .product-filter-item-wrap_special_left {
            padding: 6px 10px 0 20px;
            color: #999;
            max-width: 110px;
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: normal;
            white-space: nowrap;
        }
        .product-filter .product-filter-type .product-filter-item-wrap_special_right {
            display: flex;
            float: left;
            width: 520px;
            margin-bottom: 10px;
        }
        .product-filter .product-filter-type .product-filter-item-wrap {
            display: flex;
            float: left;
            width: 630px;
            margin-bottom: 10px;
        }
        .question-icon {
          margin-top: 5px;
        }
        .pd-addr {
            margin-bottom: 20px;
            display: flex;
        }
        .pd-l {
            line-height: 28px;
            display: inline-block;
            font-size: 12px;
            width: 50px;
            margin-right: 40px;
            color: #999;
            margin-left: 20px;
        }
        .pd-l-auto {
          height: 28px;
          display: inline-block;
          width: fit-content !important;
          margin-right: 45px;
          color: #999;
          align:left;
          margin-left: 20px;
      }
        .pd-r-content {
            vertical-align: top;
        }
        .pd-addr .cascader-tip {
            display: inline-block;
            vertical-align: middle;
            margin-left: 12px;
            position: relative;
            background: #f76149;
            border-radius: 2px;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            height: 28px;
            line-height: 28px;
            padding: 0 12px;
            color: #fff;
            font-size: 14px;
            text-align: center;
        }
        .cascader-tip:before {
            position: absolute;
            content: "";
            border-right: 6px solid #f76149;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            left: -6px;
            top: 9px;
        }
        .pd-num-input {
            display: flex;
            vertical-align: top;
        }
        :global(.ant-input-number-group-wrapper) {
          width: 130px;
        }
        .product-filter-type .product-filter-item-wrap {
          width: 630px;
          margin-bottom: 10px;
        }
        .mmu-address-selector-wrap {
          display: flex;
        }
        .mmu-address-selector-wrap :global(.cascader) {
          position: relative;
          display: inline-block;
          min-width: 150px;
          border: 1px solid #e8e8e8;
          vertical-align: middle;
          line-height: 28px;
          padding-left: 8px;
          font-size: 12px;
          padding-right: 5px;
        }
        .inventory-info {
          margin-left: 10px;
          font-size: 12px;
          display: inline-block;
          height: 28px;
          line-height: 28px;
          color: #666;
        }
      `}</style>
    </>
  );
};

type ProductDetailAttributeWithTagProps = {
  mmuAttributeListWithTag: {
    tagName: string;
    mmuAttributeList: Array<any>;
  };
  onMmuChange: () => void;
};

const ProductDetailAttributeWithTag: React.FC<ProductDetailAttributeWithTagProps> = ({
  mmuAttributeListWithTag,
  onMmuChange,
}) => {
  const { tagName, mmuAttributeList } = mmuAttributeListWithTag;

  // console.log('mmuAttributeTagList', mmuAttributeListWithTag);

  if (tagName) {
    // 存在标签
    return (
      <>
        <div key={tagName}>
          <Collapse expandIconPosition="left" key={tagName} ghost>
            <Panel header={tagName} key={tagName} className="custom-collapse-panel">
              <ProductAttributeWrapper
                mmuAttributeList={mmuAttributeList}
                onMmuChange={onMmuChange}
              />
            </Panel>
          </Collapse>
        </div>
        <style jsx global>{`
          .custom-collapse-panel .ant-collapse-header {
            color: #999 !important;
            font-size: 14px !important;
            padding: 6px 10px 0 20px !important;
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: normal;
            white-space: nowrap;
          }

          .custom-collapse-panel .ant-collapse-header-text {
            color: #999 !important;
            font-size: 16px !important;
          }

          /* 展开图标的样式 */
          .custom-collapse-panel .ant-collapse-expand-icon {
            padding-inline-end: 8px !important;
          }

          /* 内容区域的样式 */
          .custom-collapse-panel .ant-collapse-content {
            padding-top: 10px !important;
            background-color: transparent !important;
          }

          .custom-collapse-panel .ant-collapse-content-box {
            padding: 0 !important;
          }

          /* 移除折叠面板的边框 */
          .custom-collapse-panel.ant-collapse-item {
            border: none !important;
          }
        `}</style>
      </>
    );
  } else {
    // 不存在标签
    return (
      <ProductAttributeWrapper mmuAttributeList={mmuAttributeList} onMmuChange={onMmuChange} />
    );
  }
};

export default ProductDetailAttributeWithTag;
